import React, { useState, useCallback } from 'react';
import { string, exact, number, bool, func } from 'prop-types';

import { Loader, Modal } from '@atoms';
import { ConfirmationModal } from '@molecules';
import { useViewport } from '@hooks';
import { Flex, Typography } from '@mixins';
import { editAccessRequest } from '@store/globalAccess/duck';
import { GlobalAccessForm } from '@organisms';
import { useDispatch } from 'react-redux';

const EditRequestModal = ({ request, isOpen, onClose, isLoading, onRequestCancel }) => {
  const dispatch = useDispatch();
  const screenSize = useViewport();

  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);

  const handleKeepEditing = useCallback(() => {
    setIsConfirmationModalOpen(false);
  }, []);

  const handleUpdateRequest = useCallback(updatedRequest => {
    dispatch(editAccessRequest(request.id, updatedRequest));
  }, []);

  return (
    <>
      <Modal topPosition={40} onClose={onClose} isOpen={isOpen}>
        <ConfirmationModal
          title="Leaving without saving?"
          text="Are you sure you don't want to complete editing?"
          onPrimaryButtonClick={onClose}
          onSecondaryButtonClick={handleKeepEditing}
          isOpen={isConfirmationModalOpen}
          primaryButtonText="Yes, leave"
          secondaryButtonText="Keep editing"
        />
        <Flex
          {...(screenSize.height < 770 && {
            maxHeight: screenSize.height - 150,
            overflow: 'scroll',
          })}
          mt={10}
          width={[350, 400, 450, 500]}
          flexDirection="column"
          px={20}
          pb={20}>
          <Typography alignSelf="center" mb={['15px', '30px']} variant="rightserif-400" fontSize={[20, 28, 36]}>
            Update Access Request
          </Typography>
          {isLoading ? (
            <Flex justifyContent="center" flexGrow={1}>
              <Loader background="white" width={40} height={40} />
            </Flex>
          ) : (
            <GlobalAccessForm onRequestCancel={onRequestCancel} onSubmit={handleUpdateRequest} request={request} />
          )}
        </Flex>
      </Modal>
    </>
  );
};

EditRequestModal.defaultProps = {
  request: {},
  onRequestCancel: () => {},
};

EditRequestModal.propTypes = {
  onRequestCancel: func,
  isLoading: bool.isRequired,
  isOpen: bool.isRequired,
  request: exact({
    id: number,
    firstDate: string,
    secondDate: string,
    time: string,
    location: exact({
      id: number,
      image: string,
      title: string,
    }),
  }),
  onClose: func.isRequired,
};

export default EditRequestModal;
